document.addEventListener('DOMContentLoaded', function() {
    let tabs = document.querySelectorAll('.question-heading');
    let tabContent = document.querySelectorAll('.answer');

    // recorre los tabs, añade el evento click y coloca la clase active al hermano y oculta los demás
    tabs.forEach(tab => {
        tab.addEventListener('click', function() {
            let sibling = this.nextElementSibling;
            let heightTotal = sibling.scrollHeight + 40;

            tabs.forEach(t => {  
                t.classList.remove('logo');  
            });  

            if (sibling.classList.contains('active')) {
                sibling.style.height = '0px';
                sibling.classList.remove('active');
                tab.classList.remove('logo');
            } else {
                tabContent.forEach(content => {
                    content.style.height = '0px';
                    content.classList.remove('active');
                    tab.classList.remove('logo')
                });
                sibling.style.height = heightTotal + 'px';
                sibling.classList.add('active');
                tab.classList.add('logo');
            }

        });
    });
});
